import React from 'react';
import { Layout } from '../../components/Layout';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { Key, ExternalLink, ShieldCheck } from 'lucide-react';
export function PasswordSafety() {
  return <Layout data-id="element-5147">
      <div className="container mx-auto px-4 py-12" data-id="element-5148">
        <div className="mb-12" data-id="element-5149">
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-cyan-500/10 text-cyan-400 text-xs font-medium mb-4 border border-cyan-500/20" data-id="element-5150">
            <Key className="h-3 w-3 mr-2" data-id="element-5151" />
            Tools Library
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-100 mb-4" data-id="element-5152">
            Password Safety Check
          </h1>
          <p className="text-xl text-slate-400 max-w-3xl" data-id="element-5153">
            Alat untuk memeriksa kekuatan password dan apakah password tersebut
            sudah pernah bocor (compromised).
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-5154">
          <Card className="p-6" data-id="element-5155">
            <h3 className="text-xl font-bold text-slate-100 mb-2" data-id="element-5156">
              Google Password Checkup
            </h3>
            <p className="text-slate-400 mb-6 text-sm" data-id="element-5157">
              Audit seluruh password yang tersimpan di akun Google/Chrome Anda.
              Mendeteksi password lemah, dipakai ulang, atau bocor.
            </p>
            <a href="https://passwords.google.com/" target="_blank" rel="noopener noreferrer" data-id="element-5158">
              <Button className="w-full" data-id="element-5159">
                Open Google Checkup
                <ExternalLink className="ml-2 h-4 w-4" data-id="element-5160" />
              </Button>
            </a>
          </Card>

          <Card className="p-6" data-id="element-5161">
            <h3 className="text-xl font-bold text-slate-100 mb-2" data-id="element-5162">
              HIBP Pwned Passwords
            </h3>
            <p className="text-slate-400 mb-6 text-sm" data-id="element-5163">
              Cek apakah sebuah password pernah bocor. Aman digunakan karena
              menggunakan metode k-anonymity (password tidak dikirim utuh).
            </p>
            <a href="https://haveibeenpwned.com/Passwords" target="_blank" rel="noopener noreferrer" data-id="element-5164">
              <Button variant="secondary" className="w-full" data-id="element-5165">
                Check Password (Safe)
                <ExternalLink className="ml-2 h-4 w-4" data-id="element-5166" />
              </Button>
            </a>
          </Card>

          <div className="md:col-span-2" data-id="element-5167">
            <Card className="p-6 bg-slate-900/50 border-slate-800" data-id="element-5168">
              <h3 className="font-bold text-slate-100 mb-4 flex items-center" data-id="element-5169">
                <ShieldCheck className="h-5 w-5 text-cyan-500 mr-2" data-id="element-5170" />
                How k-anonymity works (Why it's safe)
              </h3>
              <p className="text-slate-400 text-sm leading-relaxed" data-id="element-5171">
                Saat Anda mengecek password di layanan terpercaya seperti HIBP,
                browser hanya mengirimkan 5 karakter pertama dari hash password
                Anda (SHA-1). Server merespons dengan ratusan hash yang cocok
                dengan 5 karakter tersebut. Pencocokan final dilakukan di
                browser Anda sendiri. Password asli Anda tidak pernah
                meninggalkan perangkat.
              </p>
            </Card>
          </div>
        </div>
      </div>
    </Layout>;
}